import PapaParse from "papaparse";
import React, { ChangeEvent } from "react";

type Props = {
    onFileLoaded: (file: any) => void;
    /**
     * Setting this to null will clear the input file
     */
    value?: string;
};

export const OwFileUploader: React.FC<Props> = (props) => {
    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.length && e.target) {
            props.onFileLoaded(e.target.files![0]);
        }
    };

    return (
        <div className={"OwFileUploader"}>
            <input className={""} type={"file"} onChange={handleFileChange} value={props.value} />
        </div>
    );
};
